import { render, staticRenderFns } from "./kbplan.vue?vue&type=template&id=0159b8f5&scoped=true"
import script from "./kbplan.vue?vue&type=script&lang=js"
export * from "./kbplan.vue?vue&type=script&lang=js"
import style0 from "./kbplan.vue?vue&type=style&index=0&id=0159b8f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0159b8f5",
  null
  
)

export default component.exports